import { getAdminBaseUrl, getAdminRemoteEntryUrl } from './utils/admin-url';

const config = {
  SERVER_PORT: import.meta.env.VITE_SERVER_PORT,
  SERVER_BASE_URL: import.meta.env.VITE_SERVER_BASE_URL,
  IS_IN_PRODUCTION: import.meta.env.VITE_IS_IN_PRODUCTION,
  AUTH0_CYPRESS_CALCULATOR_API_HOST: import.meta.env.VITE_AUTH0_CYPRESS_CALCULATOR_API_HOST,
  AUTH0_CYPRESS_SALES_API_HOST: import.meta.env.VITE_AUTH0_CYPRESS_SALES_API_HOST,
  AUTH0_ADMIN_USERNAME: import.meta.env.VITE_AUTH0_ADMIN_USERNAME,
  AUTH0_ADMIN_PASSWORD: import.meta.env.VITE_AUTH0_ADMIN_PASSWORD,
  AUTH0_SUPER_ADMIN_USERNAME: import.meta.env.VITE_AUTH0_SUPER_ADMIN_USERNAME,
  AUTH0_SUPER_ADMIN_PASSWORD: import.meta.env.VITE_AUTH0_SUPER_ADMIN_PASSWORD,
  AUTH0_WHITE_LABEL_USERNAME: import.meta.env.VITE_AUTH0_WHITE_LABEL_USERNAME,
  AUTH0_WHITE_LABEL_PASSWORD: import.meta.env.VITE_AUTH0_WHITE_LABEL_PASSWORD,
  ADMIN_BASE_URL: getAdminBaseUrl(),
  ADMIN_REMOTE_ENTRY_URL: getAdminRemoteEntryUrl(),
  GATEWAY_API_HOST: import.meta.env.VITE_GATEWAY_API_HOST,
  CUSTOMER_API_HOST: import.meta.env.VITE_CUSTOMER_API_HOST,
  CALCULATOR_NEW_API_HOST: import.meta.env.VITE_CALCULATOR_NEW_API_HOST,
  CONTRACT_API_HOST: import.meta.env.VITE_CONTRACT_API_HOST,
  SALES_API_HOST: import.meta.env.VITE_SALES_API_HOST,
};

if (!config.GATEWAY_API_HOST) {
  throw `Invalid GATEWAY_API_HOST! value found: ${config.GATEWAY_API_HOST}`;
}
export default config;
